import React, { useEffect, useState } from "react";

import "popper.js";
import "bootstrap/dist/js/bootstrap";
import { useHistory } from "react-router-dom";

// Componentes
import Foto from "../element/Foto";
import HeaderMenu from "../element/HeaderMenu";
import CarTalonario from "../element/CarTalonario";
import Menu from "../componentes/Menu";
import dataSuper from "../hooks/Conf";
import dataDireccionEstudiantil from '../hooks/useDireccionEstudiantil';
import dataFinanzas from '../hooks/useFinzas';
import CarAlumnoDatos from "../element/CarAlumnoDatos";

import GetFetch from "../helper/GetFetch";
import loadMenu from "../js/main";
import Footer from "../componentes/Footer";
import EmptyState from "../element/EmptyState";

import "../css/styleAdmin.css";

const TalonariosAdmin = () => {
  const history = useHistory();

  const [talonarios, setTalonarios] = useState({});
  const [carnet, setCarnet] = useState({});
  const [alumno, setAlumno] = useState({});

  let datos = localStorage.getItem("dataUser");

  if (!datos) {
    history.push("/");
  }

  datos = JSON.parse(datos);

  if (dataSuper.indexOf(datos.carnet.trim()) === -1) {
    if (dataDireccionEstudiantil.indexOf(datos.carnet.trim()) === -1 && dataFinanzas.indexOf(datos.carnet.trim()) === -1) {
      history.push("/");
    }
  }  

  let carnetSet = (e) => {
    setCarnet(e.target.value);
  };

  let onSutmit = (e) => {
    e.preventDefault();
    localStorage.setItem("currentCarnet", carnet);
    let talonario = GetFetch.talonarios(carnet, datos.token);
    talonario.then((dataTalonario) => {
      if (!dataTalonario.length <= 0) {
        document.getElementById("dataContenedorAlumno").style.display = "block";
        setTalonarios(dataTalonario);
        AlumnoDatos();
      } else {
        document.getElementById("dataContenedorAlumno").style.display = "block";
        setTalonarios(0)
        AlumnoDatos();
      }
      //     dataTalonario.then((dataT) => {
      //   });
    });

    let AlumnoDatos = () => {
      let datosAlum = GetFetch.datosAlumno(carnet, datos.token);
      datosAlum.then((data) => {
        if (data[0]) {
          setAlumno(data[0]);
        }else{
            setAlumno({});
        }
      });
    };
  };

  useEffect(() => {
    let currentCarnet = localStorage.getItem("currentCarnet");
    if (currentCarnet) {
      setCarnet(currentCarnet);
    } else {
      setCarnet("");
    }
    loadMenu();
    document.getElementById("textCarnet").focus();
  }, []);

  return (
    <div className="wrapper d-flex align-items-stretch">
      <nav id="sidebar">
        <div className="custom-menu">
          <button
            type="button"
            id="sidebarCollapse"
            className="btn btn-primary"
          >
            <i className="fa fa-bars"></i>
            <span className="sr-only">Toggle Menu</span>
          </button>
        </div>
        <div className="p-4">
          <Foto foto={datos.carnet} alt="Foto alumno" tamanio="rounded" />

          <HeaderMenu
            carnet={datos.carnet}
            nombre={datos.nombre}
            perfil={datos.perfil}
            carrera={datos.carrera}
            posicion="text-center"
          />

          <Menu />

          <Footer />
        </div>
      </nav>

      <div id="content" className="p-4 p-md-5 pt-5">
        <h2 className="mb-4">Talonario</h2>
        <p className="text-muted">Consulta de talonario por alumno.</p>

        <div className="card">
          <div className="card-body">
            <form id="formUP" onSubmit={onSutmit}>
              <div className="form-group">
                <label htmlFor="textCarnet">Carnet del alumno</label>
                <input
                  id="textCarnet"
                  type="text"
                  placeholder="Carnet"
                  className="form-control"
                  onChange={carnetSet}
                  autoFocus
                  value={carnet}
                />
              </div>
              <button type="submit" className="btn btn-primary">
                <i className="fa fa-search mr-2" aria-hidden="true"></i>
                Consultar
              </button>
            </form>
          </div>
        </div>

        <CarAlumnoDatos alumno={alumno} />
        {talonarios.length > 0
          ? talonarios.map((element, i) => {
              return <CarTalonario key={i} datos={element} />;
            })
          : (
            <EmptyState icon="fa-search" title="Aún no hay resultados">
              Ingresa un carnet y presiona Consultar para ver el talonario del alumno.
            </EmptyState>
          )}
      </div>
    </div>
  );
};

export default TalonariosAdmin;
